import React from "react";
import { I18nProvider } from "src/utils/localization/languages/I18nContext";
import { languageFromCode } from "src/utils/localization/languages/languages";
import { LanguageCode } from "src/utils/localization/languages/types";
import { LocationProvider } from "@gatsbyjs/reach-router";
import { BlockContentComponentsProvider } from "@silversea-ssc/ui-components-react";
import { customBlockContentComponents } from "components/BlockContent/components";
import { offerPlaceholderResolver } from "components/PlaceholderValueFormatter/resolver";

type Props = {
  languageCode: LanguageCode;
};

const SliceProviders: React.FC<React.PropsWithChildren<Props>> = ({
  languageCode,
  children
}) => {
  const language = languageFromCode(languageCode);
  return (
    <LocationProvider>
      <I18nProvider language={language}>
        <BlockContentComponentsProvider
          components={customBlockContentComponents}
          placeholderResolver={offerPlaceholderResolver}
        >
          {children}
        </BlockContentComponentsProvider>
      </I18nProvider>
    </LocationProvider>
  );
};

export default SliceProviders;
